import React, { useState } from 'react';
import Button from '../CommonComponents/Button';
import Headline from '../MainComponents/Headline';
import { login, getCurrentUser } from '../../services/AuthService';
import { useNavigate } from 'react-router-dom';
import { Wrapper, Container, Card, Label, Input, Message } from "../CommonComponents/DataCard"


function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await login(username, password);
      const userData = await getCurrentUser();

      if (userData.authenticated === true) {
        onLogin(userData);
        setSuccess(true);
        setMessage("Uspješna prijava");
        navigate('/');
      } else {
        setSuccess(false);
        setMessage("Greška pri autentifikaciji");
      }
    } catch (err) {
      setSuccess(false);
      setMessage(err.message);
    }
  };


  return (
    <Wrapper>
      <Container>
        <Card>
          <Headline size="2rem" center>Prijava</Headline>

          <Label>Korisničko ime</Label>
          <Input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />

          <Label>Lozinka</Label>
          <Input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <div onClick={() => navigate("/passwordChangeRequest")} style={{
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%"
          }}>
            <p>Zaboravili ste lozinku? Možemo Vam pomoći!</p>
          </div>

          <Button
            tekst="Prijava"
            akcija={handleLogin}
            sirina="100%"
          />

          {message && <Message $success={success}>{message}</Message>}

        </Card>
      </Container>
    </Wrapper >
  );
}

export default Login;







